import apiClient from './api';
import { ApiResponse } from '../types/api';

export interface DriverMessage {
  id: string;
  content?: string;
  images?: string[];
  is_from_driver: boolean;
  is_read: boolean;
  created_at: string;
  driver?: {
    id: string;
    name: string;
  };
  user?: {
    id: string;
    name: string;
  };
}

export interface SendMessageRequest {
  content?: string;
  images?: string[];
}

const driverMessageService = {
  /**
   * Get all messages for a delivery
   */
  getMessages: async (deliveryId: string): Promise<DriverMessage[]> => {
    const response = await apiClient.get<ApiResponse<DriverMessage[]>>(
      `/deliveries/${deliveryId}/messages`
    );
    return response.data.data;
  },

  /**
   * Send a message to the driver
   */
  sendMessage: async (
    deliveryId: string,
    message: SendMessageRequest
  ): Promise<DriverMessage> => {
    const response = await apiClient.post<ApiResponse<DriverMessage>>(
      `/deliveries/${deliveryId}/messages`,
      message
    );
    return response.data.data;
  },

  /**
   * Get count of unread messages from the driver
   */
  getUnreadCount: async (deliveryId: string): Promise<number> => {
    try {
      const response = await apiClient.get<ApiResponse<{ count: number }>>(
        `/deliveries/${deliveryId}/messages/unread`
      );
      return response.data.data?.count || 0;
    } catch (error) {
      console.error('Error fetching unread message count:', error);
      return 0;
    }
  },
};

export default driverMessageService; 